import { createBrowserRouter, Outlet } from 'react-router-dom';

import { Modals } from '@/app/global-modals';
import {
  AuthSessionScope,
  CognitoSessionGate,
  PasskeyOfferDialog,
} from '@/features/auth/components';
import { WalletAccessProvider } from '@/features/wallet-access/wallet-access-provider';
import { WalletMfaVerificationProvider } from '@/features/wallet-mfa/wallet-mfa-verification-provider';
import { Toast } from '@/shared/components/notification-popup';
import { AuthLayout } from '@/shared/modules/auth-layout';
import { FooterLayout } from '@/shared/modules/footer-layout';
import { MainLayout } from '@/shared/modules/main-layout';
import { PublicLayout } from '@/shared/modules/public-layout';
import { QuestionnaireLayout } from '@/shared/modules/questionnaire-layout';

import {
  withAuthLayoutRoutes,
  withFooterLayoutRoutes,
  withMainLayoutRoutes,
  withPublicLayoutRoutes,
  withQuestionnaireLayoutRoutes,
} from './data';
import { generateRoutes } from './helpers';
import { PagePaths } from './page-paths';
import { RouteErrorFallback } from './route-error-element';

export const routes = createBrowserRouter([
  {
    errorElement: <RouteErrorFallback fallbackTo={PagePaths.root} />,
    element: (
      <AuthSessionScope>
        <CognitoSessionGate>
          <WalletAccessProvider>
            <WalletMfaVerificationProvider>
              <Toast />
              <Modals />
              <PasskeyOfferDialog />
              <Outlet />
            </WalletMfaVerificationProvider>
          </WalletAccessProvider>
        </CognitoSessionGate>
      </AuthSessionScope>
    ),
    children: [
      {
        element: <AuthLayout />,
        children: generateRoutes(withAuthLayoutRoutes),
      },
      {
        element: <MainLayout />,
        children: generateRoutes(withMainLayoutRoutes, true),
      },
      {
        element: <PublicLayout />,
        children: generateRoutes(withPublicLayoutRoutes),
      },
      {
        element: <FooterLayout />,
        children: generateRoutes(withFooterLayoutRoutes),
      },
      {
        element: <QuestionnaireLayout />,
        children: generateRoutes(withQuestionnaireLayoutRoutes, true),
      },
    ],
  },
]);
